'use client'

import LoaderSinister from '@mercadoni/sinister/dist/cjs/mystiqueLoader'

const Loader = () => {
  return (
    <div className="loader-wrapper" style={{ minHeight: '90vh' }}>
      <LoaderSinister />
    </div>
  )
}

export default Loader
